import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { PartnerProvider } from "./context/PartnerContext";

import Home from "./pages/Home";
import Contacto from "./pages/Contacto";
import CartaAsignacion from "./pages/CartaAsignacion";
import ProgramaAdministradores from "./pages/ProgramaAdministradores";

import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCotizaciones from "./pages/AdminCotizaciones";
import AdminCartas from "./pages/AdminCartas";
import AdminClientes from "./pages/AdminClientes";
import AdminRenovaciones from "./pages/AdminRenovaciones";
import AdminComunidades from "./pages/AdminComunidades";
import AdminComunidadDetail from "./pages/AdminComunidadDetail";
import AdminCobranza from "./pages/AdminCobranza";
import AdminSiniestros from "./pages/AdminSiniestros";
import AdminMensajes from "./pages/AdminMensajes";
import AdminFormularioWeb from "./pages/AdminFormularioWeb";
import AdminSPM from "./pages/AdminSPM";
import AdminAfiliados from "./pages/AdminAfiliados";
import RegistroSPM from "./pages/RegistroSPM";
import AfiliadoPortal from "./pages/AfiliadoPortal";
import AffiliateLink from "./pages/AffiliateLink";

import PartnerLogin from "./pages/PartnerLogin";
import PartnerRegister from "./pages/PartnerRegister";
import PartnerDashboard from "./pages/PartnerDashboard";

function App() {
  return (
    <AuthProvider>
      <PartnerProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/carta-asignacion" element={<CartaAsignacion />} />
            <Route path="/SPM" element={<RegistroSPM />} />
            <Route path="/spm" element={<RegistroSPM />} />
            <Route path="/programa-administradores" element={<ProgramaAdministradores />} />

            {/* Old public quoter routes → redirect to contacto */}
            <Route path="/cotizar-comunidad" element={<Navigate to="/contacto" replace />} />
            <Route path="/cotizar-residente" element={<Navigate to="/contacto" replace />} />

            <Route path="/partner/login" element={<PartnerLogin />} />
            <Route path="/partner/register" element={<PartnerRegister />} />
            <Route path="/partner" element={<PartnerDashboard />} />

            <Route path="/afiliado" element={<AfiliadoPortal />} />
            <Route path="/afiliados" element={<AfiliadoPortal />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="mensajes" element={<AdminMensajes />} />
              <Route path="formularios-web" element={<AdminFormularioWeb />} />
              <Route path="spm" element={<AdminSPM />} />
              <Route path="afiliados" element={<AdminAfiliados />} />
              <Route path="cotizaciones" element={<AdminCotizaciones />} />
              <Route path="cartas" element={<AdminCartas />} />
              <Route path="comunidades" element={<AdminComunidades />} />
              <Route path="comunidades/:id" element={<AdminComunidadDetail />} />
              <Route path="clientes" element={<AdminClientes />} />
              <Route path="cobranza" element={<AdminCobranza />} />
              <Route path="siniestros" element={<AdminSiniestros />} />
              <Route path="renovaciones" element={<AdminRenovaciones />} />
            </Route>

            {/* Wildcard catch-all para links de afiliados: /FC, /nunoa, etc. Debe ir al FINAL. */}
            <Route path="/:codigo" element={<AffiliateLink />} />
          </Routes>
        </BrowserRouter>
      </PartnerProvider>
    </AuthProvider>
  );
}

export default App;
